// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 24 24%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M21 7L9 19L3.5 13.5L4.91 12.09L9 16.17L19.59 5.59L21 7Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.rotate {
  animation: spin 1s infinite linear;
}

.notary-rotate {
  animation: notary-spin 4s infinite linear;
}

.react-calendar {
  font-size: 16px; /* Increase font size to make the calendar larger */
}

.MuiFormControlLabel-label.Mui-required::after {
  content: none;
}

/* @media (min-width: 1200px) {
  .MuiInputLabel-root {
    width: 85%;
  }
} */

.bottomCard {
  padding-bottom: 0 !important;
}

.bottomCard-6 {
  padding-bottom: 6px !important;
}

.bottomCard-1rem {
  padding-bottom: 1rem !important;
}

/* Adjust according to your needs */
@media (min-width: 768px) {
  .react-calendar {
    font-size: 20px; /* Larger on wider screens */
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes notary-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}

.cursor-normal {
  cursor: auto !important;
}

.error-timepicker .MuiInputBase-input {
  color: red; /* Adjust as needed */
}

.custom-tooltip {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 4px;
  min-width: 7rem;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.tooltip-text {
  font-size: 18px;
  font-weight: bold;
}

.tooltip-header {
  font-size: 20px;
  font-weight: bold;
  color: #26648a;
}

.custom-tooltip > * {
  margin-bottom: 6px;
}

.iconButton:hover {
  border-radius: 15px !important;
}

/* File: src/styles.css */
.custom-checkbox {
  width: 24px;
  height: 24px;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: inline-block;
  vertical-align: middle;
}

.custom-checkbox.checked {
  background-color: #3f51b5;
  border-color: #3f51b5;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 16px;
  background-repeat: no-repeat;
  background-position: center;
}

@keyframes moveUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-5px);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes shrink {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.5);
  }
}

@keyframes grow {
  0% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}

.fadeInBtn {
  animation: fadeIn 1s forwards;
  animation: shrink 1s forwards;
}

.fadeIn {
  animation: fadeIn 2s forwards;
}

.moveUp {
  animation: moveUp 1s forwards;
}

.growBtn {
  animation: grow 1s forwards;
}

.fadeOut {
  animation: fadeOut 1s forwards;
}

.fadeInPlaceHolder1 {
  animation: fadeIn 1s forwards;
}
.fadeInPlaceHolder2 {
  animation: fadeIn 2s forwards;
}
.fadeInPlaceHolder3 {
  animation: fadeIn 3s forwards;
}
.fadeInPlaceHolder4 {
  animation: fadeIn 4s forwards;
}
.fadeInPlaceHolder5 {
  animation: fadeIn 5s forwards;
}
.fadeInPlaceHolder6 {
  animation: fadeIn 6s forwards;
}
.fadeInPlaceHolder7 {
  animation: fadeIn 7s forwards;
}
.fadeInPlaceHolder8 {
  animation: fadeIn 8s forwards;
}

/* transitions.css */
.fade-enter {
  opacity: 0;
  transition: opacity 300ms ease-in;
}

.fade-enter-active {
  opacity: 1;
}

.fade-exit {
  opacity: 1;
  transition: opacity 300ms ease-in;
}

.fade-exit-active {
  opacity: 0;
}

/* CREATE NOC FIELDS ANIMATION */

@keyframes slideIn {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideOut {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.field {
  opacity: 0;
  transform: translateY(-20px);
}

/* Opening Animations */
.open .field-1 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 0.1s; /* Delay for first field */
}

.open .field-2 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 0.3s; /* Delay for second field */
}

.open .field-3 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 0.5s; /* Delay for second field */
}

.open .field-4 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 0.7s; /* Delay for second field */
}

.open .field-5 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 0.9s; /* Delay for second field */
}

.open .field-6 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 1.1s; /* Delay for second field */
}

.open .field-7 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 1.3s; /* Delay for second field */
}

.open .field-8 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 1.5s; /* Delay for second field */
}

.open .field-9 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 1.7s; /* Delay for second field */
}

.open .field-10 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 1.9s; /* Delay for second field */
}

.open .field-11 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.1s; /* Delay for second field */
}

.open .field-12 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.3s; /* Delay for second field */
}

.open .field-13 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.5s; /* Delay for second field */
}

.open .field-14 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}

.open .field-15 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-16 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-17 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-18 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-19 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-20 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-21 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-22 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-23 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-24 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-25 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-26 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-27 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-28 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-29 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-30 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}
.open .field-31 {
  animation: slideIn 0.3s ease-in forwards;
  animation-delay: 2.7s; /* Delay for second field */
}

/* Closing Animations (Only the first 5 fields animate out) */
.closing .field-1,
.closing .field-2,
.closing .field-3,
.closing .field-4,
.closing .field-5,
.closing .field-6,
.closing .field-7,
.closing .field-8,
.closing .field-9,
.closing .field-10,
.closing .field-11,
.closing .field-12,
.closing .field-13,
.closing .field-14,
.closing .field-15,
.closing .field-16,
.closing .field-17,
.closing .field-18,
.closing .field-19,
.closing .field-20,
.closing .field-21,
.closing .field-22,
.closing .field-23,
.closing .field-24,
.closing .field-25,
.closing .field-26,
.closing .field-27,
.closing .field-28,
.closing .field-29,
.closing .field-30,
.closing .field-31 {
  animation: slideOut 0.3s ease-out forwards;
  animation-delay: 0s;
}

/* Hide fields completely when not visible */
.field {
  display: none; /* Hide by default */
}

.open .field {
  display: block; /* Display fields when opening */
}

.closing .field-1,
.closing .field-2,
.closing .field-3,
.closing .field-4,
.closing .field-5 {
  display: block; /* Keep fields visible during closing animation */
}

/* DOWNLOAD PROMO POPUP */
@keyframes popupShrink {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.1);
  }
}

@keyframes popupGrow {
  0% {
    transform: scale(0.1);
  }
  100% {
    transform: scale(1);
  }
}

.popupShrink {
  animation: popupShrink 0.3s forwards;
}

.popupGrow {
  animation: popupGrow 0.3s forwards;
}

.light-yellow-row {
  background-color: #fff4c0 !important; /* Light yellow */
}

.selected-row-color {
  background-color: #ebf1f4 !important; /* Light grey */
}

@keyframes editContractorFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media print {
  .magnifierImg {
    display: none;
  }
}

.esri-view .esri-view-surface canvas {
  pointer-events: none !important;
}

.esri-view .esri-ui {
  display: none !important;
}

.esri-view .esri-view-surface {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}

.esri-view-surface--touch-none {
  all: unset !important; /* reset any weird styles */
  width: 100% !important;
  height: 100% !important;
  display: block !important;
  pointer-events: auto !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}

/* JAXEPICS PANEL OPEN ANIMATED */
.jax-bubble-wrapper {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.1);
}

.jax-bubble-modal {
  position: fixed;
  top: var(--start-top);
  left: var(--start-left);
  overflow: hidden;
  transform: translate(-50%, -50%) scale(0.1);
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: flyToCenter 900ms ease-out forwards;
  opacity: 0;
  display: flex;
  flex-direction: column;
  z-index: 99999;
  height: 100%;
  max-height: 90vh;
}

.jax-bubble-modal.exit {
  animation: flyBack 700ms ease-in forwards;
}

.jax-panel-inner {
  opacity: 0;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.jax-panel-inner.show {
  animation: fadeInContent 300ms ease-out 900ms forwards;
}

.jax-panel-inner.show-content {
  opacity: 1;
  flex: 1 1;
  overflow-y: auto;
  box-sizing: border-box;
  height: 100%;
}

@keyframes fadeInContent {
  to {
    opacity: 1;
    padding: 24px;
  }
}

/* Animations */
@keyframes flyToCenter {
  0% {
    transform: translate(-50%, -50%) scale(0.05);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    opacity: 0;
  }

  20% {
    transform: translate(-50%, -54%) scale(0.3);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    opacity: 0.3;
  }

  40% {
    transform: translate(-50%, -53%) scale(0.5);
    width: 100px;
    height: 100px;
    border-radius: 50%;
    opacity: 0.6;
  }

  60% {
    transform: translate(-50%, -52%) scale(0.7);
    width: 180px;
    height: 180px;
    border-radius: 50%;
    opacity: 1;
  }

  80% {
    transform: translate(-50%, -50%) scale(0.9);
    width: 70vw;
    height: 60vh;
    border-radius: 30px;
  }

  100% {
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    width: 90vw;
    height: 70vh;
    max-width: 900px;
    max-height: 70vh;
    border-radius: 16px;
    opacity: 1;
  }
}

@keyframes flyBack {
  0% {
    top: 45%;
    left: 50%;
    width: 90vw;
    height: 90vh;
    max-width: 900px;
    max-height: 90vh;
    border-radius: 16px;
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  40% {
    transform: translate(-50%, -52%) scale(0.6);
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }

  80% {
    transform: translate(-50%, -54%) scale(0.2);
    width: 30px;
    height: 30px;
    opacity: 0.6;
  }

  100% {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(0.05);
    top: var(--start-top);
    left: var(--start-left);
    opacity: 0;
  }
}

@media (hover: hover) and (pointer: fine) {
  .quick-action-icon:hover {
    transform: scale(1.5);
  }
}

/* MODAL SMOOTH ANIMATION - EXACT SAME STOPS AS BEFORE */
@keyframes modalMaterialize {
  from {
    opacity: 0;
    transform: scale(0.3);
  }
  5% {
    opacity: 0.3;
    transform: translate(-50%, -50%) translateX(45vw) translateY(45vh)
      scale(0.35);
  }
  10% {
    opacity: 0.4;
    transform: translate(-50%, -50%) translateX(40vw) translateY(40vh)
      scale(0.4);
  }
  15% {
    opacity: 0.5;
    transform: translate(-50%, -50%) translateX(35vw) translateY(35vh)
      scale(0.45);
  }
  20% {
    opacity: 0.6;
    transform: translate(-50%, -50%) translateX(30vw) translateY(30vh)
      scale(0.5);
  }
  25% {
    opacity: 0.7;
    transform: translate(-50%, -50%) translateX(25vw) translateY(25vh)
      scale(0.55);
  }
  30% {
    opacity: 0.8;
    transform: translate(-50%, -50%) translateX(20vw) translateY(20vh)
      scale(0.6);
  }
  35% {
    opacity: 0.85;
    transform: translate(-50%, -50%) translateX(15vw) translateY(15vh)
      scale(0.65);
  }
  40% {
    opacity: 0.9;
    transform: translate(-50%, -50%) translateX(10vw) translateY(10vh)
      scale(0.7);
  }
  45% {
    opacity: 0.95;
    transform: translate(-50%, -50%) translateX(5vw) translateY(5vh) scale(0.75);
  }
  50% {
    opacity: 0.98;
    transform: translate(-50%, -50%) translateX(2vw) translateY(2vh) scale(0.8);
  }
  55% {
    opacity: 0.99;
    transform: translate(-50%, -50%) translateX(1vw) translateY(1vh) scale(0.85);
  }
  60% {
    opacity: 0.995;
    transform: translate(-50%, -50%) translateX(0.5vw) translateY(0.5vh)
      scale(0.9);
  }

  70% {
    opacity: 0.998;
    transform: translate(-50%, -50%) translateX(0.2vw) translateY(0.2vh)
      scale(0.94);
  }
  75% {
    opacity: 0.999;
    transform: translate(-50%, -50%) translateX(0.1vw) translateY(0.1vh)
      scale(0.96);
  }
  80% {
    opacity: 0.9995;
    transform: translate(-50%, -50%) translateX(0.05vw) translateY(0.05vh)
      scale(0.98);
  }
  85% {
    opacity: 0.9998;
    transform: translate(-50%, -50%) translateX(0.02vw) translateY(0.02vh)
      scale(0.99);
  }
  90% {
    opacity: 0.9999;
    transform: translate(-50%, -50%) translateX(0.01vw) translateY(0.01vh)
      scale(0.995);
  }
  95% {
    opacity: 0.99995;
    transform: translate(-50%, -50%) translateX(0.005vw) translateY(0.005vh)
      scale(0.998);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) translateX(0) translateY(0) scale(1);
  }
}

/* Apply the animation to modal containers */
.modal-materialize {
  animation: modalMaterialize 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

@media (max-width: 899px) {
  .reactour__popover {
    padding: 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe,EAAE,mDAAmD;AACtE;;AAEA;EACE,aAAa;AACf;;AAEA;;;;GAIG;;AAEH;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;EACE;IACE,eAAe,EAAE,4BAA4B;EAC/C;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU,EAAE,qBAAqB;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yDAA0M;EAC1M,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA,gCAAgC;;AAEhC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,wCAAwC;EACxC,qBAAqB,EAAE,0BAA0B;AACnD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;AACA;EACE,wCAAwC;EACxC,qBAAqB,EAAE,2BAA2B;AACpD;;AAEA,6DAA6D;AAC7D;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+BE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,aAAa,EAAE,oBAAoB;AACrC;;AAEA;EACE,cAAc,EAAE,gCAAgC;AAClD;;AAEA;;;;;EAKE,cAAc,EAAE,iDAAiD;AACnE;;AAEA,yBAAyB;AACzB;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC,EAAE,iBAAiB;AACzD;;AAEA;EACE,oCAAoC,EAAE,eAAe;AACvD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB,EAAE,2BAA2B;EAClD,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,8CAA8C;EAC9C,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA,eAAe;AACf;EACE;IACE,4CAA4C;IAC5C,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,2CAA2C;IAC3C,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,2CAA2C;IAC3C,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,yCAAyC;IACzC,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,yCAAyC;EAC3C;;EAEA;IACE,2CAA2C;IAC3C,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,2CAA2C;IAC3C,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;IAC5C,qBAAqB;IACrB,uBAAuB;IACvB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ;iBACa;EACf;EACA;IACE,YAAY;IACZ;gBACY;EACd;EACA;IACE,YAAY;IACZ;iBACa;EACf;EACA;IACE,YAAY;IACZ;gBACY;EACd;EACA;IACE,YAAY;IACZ;iBACa;EACf;EACA;IACE,YAAY;IACZ;gBACY;EACd;EACA;IACE,aAAa;IACb;iBACa;EACf;EACA;IACE,YAAY;IACZ;gBACY;EACd;EACA;IACE,aAAa;IACb,4EAA4E;EAC9E;EACA;IACE,aAAa;IACb,2EAA2E;EAC7E;EACA;IACE,aAAa;IACb,4EAA4E;EAC9E;EACA;IACE,cAAc;IACd;gBACY;EACd;;EAEA;IACE,cAAc;IACd;iBACa;EACf;EACA;IACE,cAAc;IACd;iBACa;EACf;EACA;IACE,eAAe;IACf;iBACa;EACf;EACA;IACE,eAAe;IACf;iBACa;EACf;EACA;IACE,eAAe;IACf;kBACc;EAChB;EACA;IACE,gBAAgB;IAChB;kBACc;EAChB;EACA;IACE,UAAU;IACV,qEAAqE;EACvE;AACF;;AAEA,4CAA4C;AAC5C;EACE,qEAAqE;AACvE;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* styles.css */\r\n.rotate {\r\n  animation: spin 1s infinite linear;\r\n}\r\n\r\n.notary-rotate {\r\n  animation: notary-spin 4s infinite linear;\r\n}\r\n\r\n.react-calendar {\r\n  font-size: 16px; /* Increase font size to make the calendar larger */\r\n}\r\n\r\n.MuiFormControlLabel-label.Mui-required::after {\r\n  content: none;\r\n}\r\n\r\n/* @media (min-width: 1200px) {\r\n  .MuiInputLabel-root {\r\n    width: 85%;\r\n  }\r\n} */\r\n\r\n.bottomCard {\r\n  padding-bottom: 0 !important;\r\n}\r\n\r\n.bottomCard-6 {\r\n  padding-bottom: 6px !important;\r\n}\r\n\r\n.bottomCard-1rem {\r\n  padding-bottom: 1rem !important;\r\n}\r\n\r\n/* Adjust according to your needs */\r\n@media (min-width: 768px) {\r\n  .react-calendar {\r\n    font-size: 20px; /* Larger on wider screens */\r\n  }\r\n}\r\n\r\n@keyframes spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes notary-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(-360deg);\r\n  }\r\n}\r\n\r\n.cursor-normal {\r\n  cursor: auto !important;\r\n}\r\n\r\n.error-timepicker .MuiInputBase-input {\r\n  color: red; /* Adjust as needed */\r\n}\r\n\r\n.custom-tooltip {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  min-width: 7rem;\r\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.tooltip-text {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n}\r\n\r\n.tooltip-header {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: #26648a;\r\n}\r\n\r\n.custom-tooltip > * {\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.iconButton:hover {\r\n  border-radius: 15px !important;\r\n}\r\n\r\n/* File: src/styles.css */\r\n.custom-checkbox {\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.custom-checkbox.checked {\r\n  background-color: #3f51b5;\r\n  border-color: #3f51b5;\r\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' fill='white' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21 7L9 19L3.5 13.5L4.91 12.09L9 16.17L19.59 5.59L21 7Z'/%3E%3C/svg%3E\");\r\n  background-size: 16px;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n}\r\n\r\n@keyframes moveUp {\r\n  0% {\r\n    transform: translateY(0);\r\n  }\r\n  100% {\r\n    transform: translateY(-5px);\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes fadeOut {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@keyframes shrink {\r\n  0% {\r\n    transform: scale(1);\r\n  }\r\n  100% {\r\n    transform: scale(0.5);\r\n  }\r\n}\r\n\r\n@keyframes grow {\r\n  0% {\r\n    transform: scale(0.5);\r\n  }\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.fadeInBtn {\r\n  animation: fadeIn 1s forwards;\r\n  animation: shrink 1s forwards;\r\n}\r\n\r\n.fadeIn {\r\n  animation: fadeIn 2s forwards;\r\n}\r\n\r\n.moveUp {\r\n  animation: moveUp 1s forwards;\r\n}\r\n\r\n.growBtn {\r\n  animation: grow 1s forwards;\r\n}\r\n\r\n.fadeOut {\r\n  animation: fadeOut 1s forwards;\r\n}\r\n\r\n.fadeInPlaceHolder1 {\r\n  animation: fadeIn 1s forwards;\r\n}\r\n.fadeInPlaceHolder2 {\r\n  animation: fadeIn 2s forwards;\r\n}\r\n.fadeInPlaceHolder3 {\r\n  animation: fadeIn 3s forwards;\r\n}\r\n.fadeInPlaceHolder4 {\r\n  animation: fadeIn 4s forwards;\r\n}\r\n.fadeInPlaceHolder5 {\r\n  animation: fadeIn 5s forwards;\r\n}\r\n.fadeInPlaceHolder6 {\r\n  animation: fadeIn 6s forwards;\r\n}\r\n.fadeInPlaceHolder7 {\r\n  animation: fadeIn 7s forwards;\r\n}\r\n.fadeInPlaceHolder8 {\r\n  animation: fadeIn 8s forwards;\r\n}\r\n\r\n/* transitions.css */\r\n.fade-enter {\r\n  opacity: 0;\r\n  transition: opacity 300ms ease-in;\r\n}\r\n\r\n.fade-enter-active {\r\n  opacity: 1;\r\n}\r\n\r\n.fade-exit {\r\n  opacity: 1;\r\n  transition: opacity 300ms ease-in;\r\n}\r\n\r\n.fade-exit-active {\r\n  opacity: 0;\r\n}\r\n\r\n/* CREATE NOC FIELDS ANIMATION */\r\n\r\n@keyframes slideIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes slideOut {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n  }\r\n}\r\n\r\n.field {\r\n  opacity: 0;\r\n  transform: translateY(-20px);\r\n}\r\n\r\n/* Opening Animations */\r\n.open .field-1 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 0.1s; /* Delay for first field */\r\n}\r\n\r\n.open .field-2 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 0.3s; /* Delay for second field */\r\n}\r\n\r\n.open .field-3 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 0.5s; /* Delay for second field */\r\n}\r\n\r\n.open .field-4 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 0.7s; /* Delay for second field */\r\n}\r\n\r\n.open .field-5 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 0.9s; /* Delay for second field */\r\n}\r\n\r\n.open .field-6 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 1.1s; /* Delay for second field */\r\n}\r\n\r\n.open .field-7 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 1.3s; /* Delay for second field */\r\n}\r\n\r\n.open .field-8 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 1.5s; /* Delay for second field */\r\n}\r\n\r\n.open .field-9 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 1.7s; /* Delay for second field */\r\n}\r\n\r\n.open .field-10 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 1.9s; /* Delay for second field */\r\n}\r\n\r\n.open .field-11 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.1s; /* Delay for second field */\r\n}\r\n\r\n.open .field-12 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.3s; /* Delay for second field */\r\n}\r\n\r\n.open .field-13 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.5s; /* Delay for second field */\r\n}\r\n\r\n.open .field-14 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n\r\n.open .field-15 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-16 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-17 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-18 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-19 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-20 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-21 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-22 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-23 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-24 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-25 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-26 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-27 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-28 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-29 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-30 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n.open .field-31 {\r\n  animation: slideIn 0.3s ease-in forwards;\r\n  animation-delay: 2.7s; /* Delay for second field */\r\n}\r\n\r\n/* Closing Animations (Only the first 5 fields animate out) */\r\n.closing .field-1,\r\n.closing .field-2,\r\n.closing .field-3,\r\n.closing .field-4,\r\n.closing .field-5,\r\n.closing .field-6,\r\n.closing .field-7,\r\n.closing .field-8,\r\n.closing .field-9,\r\n.closing .field-10,\r\n.closing .field-11,\r\n.closing .field-12,\r\n.closing .field-13,\r\n.closing .field-14,\r\n.closing .field-15,\r\n.closing .field-16,\r\n.closing .field-17,\r\n.closing .field-18,\r\n.closing .field-19,\r\n.closing .field-20,\r\n.closing .field-21,\r\n.closing .field-22,\r\n.closing .field-23,\r\n.closing .field-24,\r\n.closing .field-25,\r\n.closing .field-26,\r\n.closing .field-27,\r\n.closing .field-28,\r\n.closing .field-29,\r\n.closing .field-30,\r\n.closing .field-31 {\r\n  animation: slideOut 0.3s ease-out forwards;\r\n  animation-delay: 0s;\r\n}\r\n\r\n/* Hide fields completely when not visible */\r\n.field {\r\n  display: none; /* Hide by default */\r\n}\r\n\r\n.open .field {\r\n  display: block; /* Display fields when opening */\r\n}\r\n\r\n.closing .field-1,\r\n.closing .field-2,\r\n.closing .field-3,\r\n.closing .field-4,\r\n.closing .field-5 {\r\n  display: block; /* Keep fields visible during closing animation */\r\n}\r\n\r\n/* DOWNLOAD PROMO POPUP */\r\n@keyframes popupShrink {\r\n  0% {\r\n    transform: scale(1);\r\n  }\r\n  100% {\r\n    transform: scale(0.1);\r\n  }\r\n}\r\n\r\n@keyframes popupGrow {\r\n  0% {\r\n    transform: scale(0.1);\r\n  }\r\n  100% {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.popupShrink {\r\n  animation: popupShrink 0.3s forwards;\r\n}\r\n\r\n.popupGrow {\r\n  animation: popupGrow 0.3s forwards;\r\n}\r\n\r\n.light-yellow-row {\r\n  background-color: #fff4c0 !important; /* Light yellow */\r\n}\r\n\r\n.selected-row-color {\r\n  background-color: #ebf1f4 !important; /* Light grey */\r\n}\r\n\r\n@keyframes editContractorFadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@media print {\r\n  .magnifierImg {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.esri-view .esri-view-surface canvas {\r\n  pointer-events: none !important;\r\n}\r\n\r\n.esri-view .esri-ui {\r\n  display: none !important;\r\n}\r\n\r\n.esri-view .esri-view-surface {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  border: none !important;\r\n}\r\n\r\n.esri-view-surface--touch-none {\r\n  all: unset !important; /* reset any weird styles */\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  display: block !important;\r\n  pointer-events: auto !important;\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  border: none !important;\r\n}\r\n\r\n/* JAXEPICS PANEL OPEN ANIMATED */\r\n.jax-bubble-wrapper {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 99999;\r\n  background: rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.jax-bubble-modal {\r\n  position: fixed;\r\n  top: var(--start-top);\r\n  left: var(--start-left);\r\n  overflow: hidden;\r\n  transform: translate(-50%, -50%) scale(0.1);\r\n  border-radius: 50%;\r\n  background: #fff;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\r\n  animation: flyToCenter 900ms ease-out forwards;\r\n  opacity: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  z-index: 99999;\r\n  height: 100%;\r\n  max-height: 90vh;\r\n}\r\n\r\n.jax-bubble-modal.exit {\r\n  animation: flyBack 700ms ease-in forwards;\r\n}\r\n\r\n.jax-panel-inner {\r\n  opacity: 0;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow-y: auto;\r\n}\r\n\r\n.jax-panel-inner.show {\r\n  animation: fadeInContent 300ms ease-out 900ms forwards;\r\n}\r\n\r\n.jax-panel-inner.show-content {\r\n  opacity: 1;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  box-sizing: border-box;\r\n  height: 100%;\r\n}\r\n\r\n@keyframes fadeInContent {\r\n  to {\r\n    opacity: 1;\r\n    padding: 24px;\r\n  }\r\n}\r\n\r\n/* Animations */\r\n@keyframes flyToCenter {\r\n  0% {\r\n    transform: translate(-50%, -50%) scale(0.05);\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 50%;\r\n    opacity: 0;\r\n  }\r\n\r\n  20% {\r\n    transform: translate(-50%, -54%) scale(0.3);\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    opacity: 0.3;\r\n  }\r\n\r\n  40% {\r\n    transform: translate(-50%, -53%) scale(0.5);\r\n    width: 100px;\r\n    height: 100px;\r\n    border-radius: 50%;\r\n    opacity: 0.6;\r\n  }\r\n\r\n  60% {\r\n    transform: translate(-50%, -52%) scale(0.7);\r\n    width: 180px;\r\n    height: 180px;\r\n    border-radius: 50%;\r\n    opacity: 1;\r\n  }\r\n\r\n  80% {\r\n    transform: translate(-50%, -50%) scale(0.9);\r\n    width: 70vw;\r\n    height: 60vh;\r\n    border-radius: 30px;\r\n  }\r\n\r\n  100% {\r\n    top: 45%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%) scale(1);\r\n    width: 90vw;\r\n    height: 70vh;\r\n    max-width: 900px;\r\n    max-height: 70vh;\r\n    border-radius: 16px;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes flyBack {\r\n  0% {\r\n    top: 45%;\r\n    left: 50%;\r\n    width: 90vw;\r\n    height: 90vh;\r\n    max-width: 900px;\r\n    max-height: 90vh;\r\n    border-radius: 16px;\r\n    opacity: 1;\r\n    transform: translate(-50%, -50%) scale(1);\r\n  }\r\n\r\n  40% {\r\n    transform: translate(-50%, -52%) scale(0.6);\r\n    width: 100px;\r\n    height: 100px;\r\n    border-radius: 50%;\r\n  }\r\n\r\n  80% {\r\n    transform: translate(-50%, -54%) scale(0.2);\r\n    width: 30px;\r\n    height: 30px;\r\n    opacity: 0.6;\r\n  }\r\n\r\n  100% {\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 50%;\r\n    transform: translate(-50%, -50%) scale(0.05);\r\n    top: var(--start-top);\r\n    left: var(--start-left);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n@media (hover: hover) and (pointer: fine) {\r\n  .quick-action-icon:hover {\r\n    transform: scale(1.5);\r\n  }\r\n}\r\n\r\n/* MODAL SMOOTH ANIMATION - EXACT SAME STOPS AS BEFORE */\r\n@keyframes modalMaterialize {\r\n  from {\r\n    opacity: 0;\r\n    transform: scale(0.3);\r\n  }\r\n  5% {\r\n    opacity: 0.3;\r\n    transform: translate(-50%, -50%) translateX(45vw) translateY(45vh)\r\n      scale(0.35);\r\n  }\r\n  10% {\r\n    opacity: 0.4;\r\n    transform: translate(-50%, -50%) translateX(40vw) translateY(40vh)\r\n      scale(0.4);\r\n  }\r\n  15% {\r\n    opacity: 0.5;\r\n    transform: translate(-50%, -50%) translateX(35vw) translateY(35vh)\r\n      scale(0.45);\r\n  }\r\n  20% {\r\n    opacity: 0.6;\r\n    transform: translate(-50%, -50%) translateX(30vw) translateY(30vh)\r\n      scale(0.5);\r\n  }\r\n  25% {\r\n    opacity: 0.7;\r\n    transform: translate(-50%, -50%) translateX(25vw) translateY(25vh)\r\n      scale(0.55);\r\n  }\r\n  30% {\r\n    opacity: 0.8;\r\n    transform: translate(-50%, -50%) translateX(20vw) translateY(20vh)\r\n      scale(0.6);\r\n  }\r\n  35% {\r\n    opacity: 0.85;\r\n    transform: translate(-50%, -50%) translateX(15vw) translateY(15vh)\r\n      scale(0.65);\r\n  }\r\n  40% {\r\n    opacity: 0.9;\r\n    transform: translate(-50%, -50%) translateX(10vw) translateY(10vh)\r\n      scale(0.7);\r\n  }\r\n  45% {\r\n    opacity: 0.95;\r\n    transform: translate(-50%, -50%) translateX(5vw) translateY(5vh) scale(0.75);\r\n  }\r\n  50% {\r\n    opacity: 0.98;\r\n    transform: translate(-50%, -50%) translateX(2vw) translateY(2vh) scale(0.8);\r\n  }\r\n  55% {\r\n    opacity: 0.99;\r\n    transform: translate(-50%, -50%) translateX(1vw) translateY(1vh) scale(0.85);\r\n  }\r\n  60% {\r\n    opacity: 0.995;\r\n    transform: translate(-50%, -50%) translateX(0.5vw) translateY(0.5vh)\r\n      scale(0.9);\r\n  }\r\n\r\n  70% {\r\n    opacity: 0.998;\r\n    transform: translate(-50%, -50%) translateX(0.2vw) translateY(0.2vh)\r\n      scale(0.94);\r\n  }\r\n  75% {\r\n    opacity: 0.999;\r\n    transform: translate(-50%, -50%) translateX(0.1vw) translateY(0.1vh)\r\n      scale(0.96);\r\n  }\r\n  80% {\r\n    opacity: 0.9995;\r\n    transform: translate(-50%, -50%) translateX(0.05vw) translateY(0.05vh)\r\n      scale(0.98);\r\n  }\r\n  85% {\r\n    opacity: 0.9998;\r\n    transform: translate(-50%, -50%) translateX(0.02vw) translateY(0.02vh)\r\n      scale(0.99);\r\n  }\r\n  90% {\r\n    opacity: 0.9999;\r\n    transform: translate(-50%, -50%) translateX(0.01vw) translateY(0.01vh)\r\n      scale(0.995);\r\n  }\r\n  95% {\r\n    opacity: 0.99995;\r\n    transform: translate(-50%, -50%) translateX(0.005vw) translateY(0.005vh)\r\n      scale(0.998);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translate(-50%, -50%) translateX(0) translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n/* Apply the animation to modal containers */\r\n.modal-materialize {\r\n  animation: modalMaterialize 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n@media (max-width: 899px) {\r\n  .reactour__popover {\r\n    padding: 12px !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
